<template>
  <div class="modal-detailpo">
    <div class="mdp-wrapper">
      <div class="mdp-title">PERIODE PO</div>
      <div class="mdp-radio" v-for="(item, index) in filters" :key="index">
        <label class="mr20" :for="item.value">
          <input
            class="mr5"
            type="radio"
            :value="item.value"
            name="PERIODE PO"
            v-model="choosePeriodePO"
          />
          {{ item.name }}
        </label>
      </div>
    </div>
    <div class="custom-po">
      <div class="text-danger text-bold">Kostum</div>
      <div class="input-wrap">
        <input type="date" v-model="poStartDate" />
      </div>
      <div>s/d</div>
      <div class="input-wrap">
        <input type="date" v-model="poEndDate" />
      </div>
      <div @click="runCustomDate()">
        <strong class="search-icons"><i class="fas fa-search"></i></strong>
      </div>
    </div>
    <div v-show="chartPo" v-if="$get($store, 'state.permissions.33.allow')">
      <ChartDetailPO :chartData="chartData" :options="options" :height="275" />
    </div>
    <div class="total-nominal-container" v-if="totalPo">
      <div
        class="nominal-wrapper"
        v-if="$get($store, 'state.permissions.33.allow')"
      >
        <div class="tn-title">Total PO</div>
        <div class="tn-devider">:</div>
        <div class="tn-nominal">{{ totalPo.total_po }}</div>
      </div>
      <div
        class="nominal-wrapper"
        v-if="$get($store, 'state.permissions.33.allow')"
      >
        <div class="tn-title">Total Nominal USD</div>
        <div class="tn-devider">:</div>
        <div class="tn-nominal">
          {{ curencyDelimiter(totalPo.total_value_usd) }}
        </div>
      </div>
      <div
        class="nominal-wrapper"
        v-if="$get($store, 'state.permissions.33.allow')"
      >
        <div class="tn-title">Total Nominal IDR</div>
        <div class="tn-devider">:</div>
        <div class="tn-nominal">
          {{ curencyDelimiter(totalPo.total_value_idr) }}
        </div>
      </div>
    </div>
    <div class="po-list-wrapper" v-if="detailPo">
      <div class="po-list text-bold">
        <div class="po-list__no">No</div>
        <div class="po-list__type">Jenis PO</div>
        <div class="po-list__type">Nomor PO</div>
        <div
          class="po-list__nominal text-center"
          v-if="$get($store, 'state.permissions.33.allow')"
        >
          Nominal USD
        </div>
        <div
          class="po-list__nominal text-center"
          v-if="$get($store, 'state.permissions.33.allow')"
        >
          Nominal IDR
        </div>
        <div class="po-list__date po-list__hover" @click="sortDate()">
          Tanggal PO
          <i
            class="fas fa-sort-numeric-down-alt"
            v-show="$store.state.level1.detailPoOrder == 'desc'"
          ></i
          ><i
            class="fas fa-sort-numeric-up"
            v-show="$store.state.level1.detailPoOrder == 'asc'"
          ></i>
        </div>
      </div>
      <div class="po-list" v-for="(list, index) in detailPo" :key="index">
        <div class="po-list__no">{{ index + 1 }}</div>
        <div class="po-list__type">{{ list.PO_TYPE }}</div>
        <div class="po-list__type">{{ list.PO_NUMBER }}</div>
        <div
          class="po-list__nominal text-right"
          v-if="$get($store, 'state.permissions.33.allow')"
        >
          {{ curencyDelimiter(list.TOTAL_VALUE_USD) }}
        </div>
        <div
          class="po-list__nominal text-right"
          v-if="$get($store, 'state.permissions.33.allow')"
        >
          {{ curencyDelimiter(list.TOTAL_VALUE_IDR) }}
        </div>
        <div class="po-list__date">{{ checkDate(list.PO_DATE) }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import numeral from 'numeral'
export default {
  components: {
    ChartDetailPO: () => import('@/components/chart/ChartDetailPO'),
  },
  data() {
    return {
      sortMode: false,
      filters: [
        {
          name: '3 Bulan',
          value: '3',
        },
        {
          name: '6 Bulan',
          value: '6',
        },
        {
          name: '12 Bulan',
          value: '12',
        },
      ],
      currentPage: 1,
      totalPerPage: 20,
      chartData: null,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        title: {
          display: true,
          text: 'Detail PO',
        },
        legend: {
          display: true,
          position: 'bottom',
        },
        tooltips: {
          mode: 'index',
          axis: 'y',
          callbacks: {
            label: function(tooltipItem, data) {
              let label = data.datasets[tooltipItem.datasetIndex].label || ''

              if (label) {
                label += ': '
              }
              // label += Math.round(tooltipItem.yLabel * 100) / 100;
              let idr = numeral(tooltipItem.yLabel).format('0,0.00')
              let newIdr = ''
              idr.split('').map(list => {
                if (list == ',') {
                  newIdr += '.'
                } else if (list == '.') {
                  newIdr += ','
                } else {
                  newIdr += list
                }
              })

              label += newIdr
              return label
            },
          },
        },
        scales: {
          yAxes: [
            {
              id: 'A',
              type: 'linear',
              position: 'right',
              scaleLabel: {
                display: true,
                labelString: 'Nilai USD',
              },
              ticks: {
                beginAtZero: true,
                callback: function(value, index, values) {
                  let idr = numeral(value).format('0,0.00')
                  let newIdr = ''
                  idr.split('').map(list => {
                    if (list == ',') {
                      newIdr += '.'
                    } else if (list == '.') {
                      newIdr += ','
                    } else {
                      newIdr += list
                    }
                  })
                  return newIdr
                },
              },
              grid: {
                drawOnChartArea: false, // only want the grid lines for one axis to show up
              },
            },
            {
              id: 'B',
              type: 'linear',
              position: 'left',
              scaleLabel: {
                display: true,
                labelString: 'Nilai IDR',
              },
              ticks: {
                beginAtZero: true,
                callback: function(value, index, values) {
                  let idr = numeral(value).format('0,0.00')
                  let newIdr = ''
                  idr.split('').map(list => {
                    if (list == ',') {
                      newIdr += '.'
                    } else if (list == '.') {
                      newIdr += ','
                    } else {
                      newIdr += list
                    }
                  })
                  return newIdr
                },
              },
              grid: {
                drawOnChartArea: false, // only want the grid lines for one axis to show up
              },
            },
          ],
        },
      },
    }
  },
  computed: {
    chartPo() {
      this.seriesData(this.$store.state.level1.chartPo)
      return this.$store.state.level1.chartPo
    },
    totalPo() {
      return this.$store.state.level1.totalPo
    },
    detailPo() {
      return this.$store.state.level1.detailPo
    },
    choosePeriodePO: {
      get: function() {
        return this.$store.state.searchStore.choosePeriodePO
      },
      set: async function(newValue) {
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'poStartDate',
          value: this.monthFromNow(newValue),
        })
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'poEndDate',
          value: this.$now(),
        })
        await this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'choosePeriodePO',
          value: newValue,
        })

        let query = {
          poStart: `${this.monthFromNow(newValue)}`,
          poEnd: `${this.$now()}`,
        }

        await this.$store.commit('level1/CUSTOM_DETAIL_PO', query)
      },
    },
    poStartDate: {
      get: function() {
        return this.$store.state.searchStore.poStartDate
      },
      set: function(newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'poStartDate',
          value: newValue,
        })
      },
    },
    poEndDate: {
      get: function() {
        return this.$store.state.searchStore.poEndDate
      },
      set: function(newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'poEndDate',
          value: newValue,
        })
      },
    },
  },
  methods: {
    compareDesc(a, b) {
      if (a.PO_DATE > b.PO_DATE) {
        return -1
      }
      if (a.PO_DATE < b.PO_DATE) {
        return 1
      }
      return 0
    },
    compareAsc(a, b) {
      if (a.PO_DATE < b.PO_DATE) {
        return -1
      }
      if (a.PO_DATE > b.PO_DATE) {
        return 1
      }
      return 0
    },
    async runCustomDate() {
      const query = {
        poStart: `${this.poStartDate}`,
        poEnd: `${this.poEndDate}`,
      }

      await this.$store.commit('level1/CUSTOM_DETAIL_PO', query)
    },
    sortDate() {
      this.$store.commit('level1/ORDER_DETAIL_PO')
    },
    checkDate(value) {
      if (value && moment(value).isValid()) {
        return moment(value).format('DD MMM YYYY')
      }
    },
    itemPO() {
      const self = this
      if (self.items) {
        return self.items
      }
      return []
    },
    monthCategories() {
      const self = this
      const dateFormat = { month: 'short', year: 'numeric' }
      if (self.items) {
        const items = self.items

        let data = {}
        for (let i in items) {
          const event = new Date(items[i].PO_DATE).toLocaleString(
            'en-GB',
            dateFormat
          )
          if (data[`${event}`] == undefined) {
            data[`${event}`] = {
              po_value: items[i]['TOTAL_VALUE_USD'],
              po_value_idr: items[i]['TOTAL_VALUE_IDR'],
            }
          } else {
            data[`${event}`] = {
              po_value:
                items[i]['TOTAL_VALUE_USD'] + data[`${event}`]['po_value'],
              po_value_idr:
                items[i]['TOTAL_VALUE_IDR'] + data[`${event}`]['po_value_idr'],
            }
          }
        }
        return data
      }
      return []
    },
    seriesData(items) {
      const self = this
      this.reRenderChart = false

      let categories = []
      let po_value_idr = []
      let po_value_usd = []

      items &&
        items.forEach(list => {
          categories.push(
            `${self.monthConverter(list.month)} '${self.twoDigitYear(
              list.year
            )}`
          )
          po_value_idr.push(this.convertNumberDescimal(list.total_value_idr))
          po_value_usd.push(this.convertNumberDescimal(list.total_value_usd))
        })

      this.chartData = {
        labels: categories,
        datasets: [
          {
            label: 'Nilai IDR',
            backgroundColor: '#990000',
            borderColor: '#990000',
            data: po_value_idr,
            yAxisID: 'B',
            fill: false,
            lineTension: 0,
          },
          {
            label: 'Nilai USD',
            backgroundColor: '#ff9966',
            borderColor: '#ff9966',
            data: po_value_usd,
            type: 'line',
            yAxisID: 'A',
            fill: false,
            lineTension: 0,
          },
        ],
      }

      this.$nextTick(() => {
        this.reRenderChart = true
      })
    },
  },
}
</script>
<style lang="scss">
@import '~/assets/scss/components/poReleased.scss';
</style>
